// SubActionContext.js
import React, { createContext, useState } from "react";

export const SubActionContext = createContext();

export const SubActionProvider = ({ children }) => {
  const [subActions, setSubActions] = useState([
    { id: 1, name: "Teknisyen Yönlendir" },
    { id: 2, name: "Haber Verecek" },
    { id: 3, name: "Müşteri İptal Etti" },
    { id: 4, name: "Teyid Araması" },
    { id: 5, name: "Cihaz Tamir Edilemiyor" },
    { id: 6, name: "Şikayetçi" },
    { id: 7, name: "Yeniden Teknisyen Yönlendir" },
    { id: 8, name: "Servis Sonlandırıldı" },
    { id: 9, name: "Tahsilata Gönder" },
    { id: 10, name: "Yerinde Bakım Yapıldı" },
    { id: 11, name: "Fiyatta Anlaşılamadı" },
    { id: 12, name: "Müşteriye Ulaşılamadı" },
    { id: 13, name: "Atölyeye Alındı" },
    { id: 14, name: "Parçası Atölyeye Alındı" },
    { id: 15, name: "Parça Gidecek" },
    { id: 16, name:  "Cihaz Teslim Edildi" },
    
  ]);

  const addSubAction = (name) => {
    const newSub = { id: Date.now(), name };
    setSubActions((prev) => [...prev, newSub]);
  };

  const deleteSubAction = (id) => {
    setSubActions((prev) => prev.filter((s) => s.id !== id));
  };

  return (
    <SubActionContext.Provider
      value={{ subActions, addSubAction, deleteSubAction }}
    >
      {children}
    </SubActionContext.Provider>
  );
};
